const translations:object = {
    'en': {
        'error.technical': 'There was a technical error. Please try again. If the issue persists contact our support team.',
        'error.client-inactive': 'The client your user is associated with is no longer active.',
        'error.not-found': 'User not found.',
    }
};

export default translations
